// extracted by mini-css-extract-plugin
module.exports = {"Caption":"Caption_Caption__pQ2_6","Caption___primary":"Caption_Caption___primary__aS_Pa","Caption___secondary":"Caption_Caption___secondary__nhaPf"};